/**
 * Returns the current page URL.
 * This may eventually change to a short URL generator - strt.mx
 */
export function getSharingUrl () {
  return window.location.href
}
